import { render, staticRenderFns } from "./DisposalDetail.vue?vue&type=template&id=132ef5b8&scoped=true&"
import script from "./DisposalDetail.vue?vue&type=script&lang=js&"
export * from "./DisposalDetail.vue?vue&type=script&lang=js&"
import style0 from "./DisposalDetail.vue?vue&type=style&index=0&id=132ef5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ef5b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
